import http from "../../http-common";

const get = (data) => http.post("/ProgramRole/FilterProgramRole", data);

const create = (data) => http.post("/ProgramRole/InsertProgramRole", data);

const remove = (data) =>
  http.request({
    url: "/ProgramRole/DeleteProgramRole",
    method: "delete",
    data: data,
  });

export default { get, create, remove };
